// sessionStorage操作
export function setStore(name, content) {
    if (!name) {
        return;
    }
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.sessionStorage.setItem(name, content);
}
export function getStore(name) {
    let rtn = '';

    if (name) {
        rtn = JSON.parse(window.sessionStorage.getItem(name));
    }
    return rtn;
}
export function removeStore(name) {
    if (!name) {
        return;
    }
    window.sessionStorage.removeItem(name);
}

export function rem(size = 750) {
    let docEl = document.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        reCalc = () => {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            var ratio;
            if(docEl.clientHeight > docEl.clientWidth) {
                ratio = docEl.clientWidth / 750
            } else {
                ratio = docEl.clientHeight / 750
            }
            docEl.style.fontSize = 100 * (ratio) + 'px';
        };

    if (!document.addEventListener) return;
    reCalc();
    window.addEventListener(resizeEvt, reCalc, false);
    document.addEventListener('DOMContentLoaded', reCalc, false);
}

export function isWeiXin() {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}

export function isAndroid() {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
}

export function isMobile() {
    // if (/Wechat/.test(navigator.userAgent)) {
    //     return false;
    // }
    if (
        /AppleWebKit.*Mobile/i.test(navigator.userAgent) ||
        /Android|iPhone|Windows Phone|webOS|iPod|BlackBerry/i.test(navigator.userAgent)
    ) {
        return true;
    }
    return false;
}

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


export function getUrlParams(url) {
    if (!url) url = window.location.href;
    const queryString = url.split('?')[1];
    const params = queryString.split('&');
    const obj = {};

    params.forEach(param => {
      const [key, value] = param.split('=');
      obj[decodeURIComponent(key)] = decodeURIComponent(value);
    });

    return obj;
}

export function redirectTo(content) {
    var chksys = function () {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf('android') != -1) {
            return 'Android';
        } else if (userAgent.indexOf('macintosh') != -1 /* || userAgent.indexOf('mac os x') != -1*/ ) {
            return 'MAC';
        } else if (userAgent.indexOf('iphone') != -1 || userAgent.indexOf('ipad') != -1 || userAgent.indexOf('ipod') != -1 || userAgent.indexOf('ios') != -1) {
            return 'IOS';
        } else if (userAgent.indexOf('windows') != -1 || userAgent.indexOf('win32') != -1) {
            return 'Windows';
        }
        return 'unknown';
    };

    //向游戏发送消息内容
    try {
        switch (chksys()) {
            case 'IOS':
                window.location = "objc://change_findpassword_view_js?url=" + content;
                window.webkit.messageHandlers.webviewConnect.postMessage(content);
                break;
            case 'MAC':
                window.webkit.messageHandlers.webviewConnect.postMessage(content);
                break;
            case 'Android':
                window.WebviewConnectObject.webviewConnect(content);
                break;
            case 'Windows':
                window.bridge.webviewConnect(content);
                break;
            default:
                document.appendChild(navigator.userAgent.toLowerCase());
                break;
        }
    } catch (e) {
        //alert(e.message);
    }
}
